import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "actionsButton", "dropdownRoot"]

  connect() {
    this.update()
  }

  update() {
    const anyChecked = this.checkboxTargets.some((cb) => cb.checked)
    this.actionsButtonTarget.disabled = !anyChecked
    this.actionsButtonTarget.classList.toggle("opacity-50", !anyChecked)
    this.actionsButtonTarget.classList.toggle("cursor-not-allowed", !anyChecked)
    this.actionsButtonTarget.classList.toggle("hover:bg-gray-50", anyChecked)

    if (!anyChecked && this.hasDropdownRootTarget) {
      const menu = this.dropdownRootTarget.querySelector('[data-dropdown-target="menu"]')
      if (menu) menu.classList.add("hidden")
    }
  }
}

